import React, { Component } from 'react';
import { Grid, Container, Statistic } from 'semantic-ui-react';

import CoverageChart from '../../Charts/CoverageChart';
import DuplicateCodeChart from '../../Charts/DuplicateCodeChart';
import LOCChart from '../../Charts/LOCChart';
import MaintainabilityChart from '../../Charts/MaintainabilityChart';
import UnitTestChart from '../../Charts/UnitTestChart';


class GraphsSection extends Component
{
   render()
    {
        const report        = this.props.report,
            reportHelper    = this.props.reportHelper,
            match           = this.props.match,
            pkg             = this.props.pkg;

        return (
            <Container className='Graphs'>
                <Grid celled={false} columns={16} stackable={true} stretched={true}>
                    <Grid.Row className={`coverage ${report.data.info.categoryStatus.coverage.status}`}>
                        <Grid.Column width={4}>
                            <Statistic>
                                <Statistic.Label>Coverage</Statistic.Label>
                                <Statistic.Value>
                                    {reportHelper.getCoverageScore().coverage}%
                                    <small>({reportHelper.getCoverageChange()})</small>
                                </Statistic.Value>
                            </Statistic>
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <CoverageChart pkg={pkg} fetchType={match.params.fetchType} />
                        </Grid.Column>
                    </Grid.Row>


                    <Grid.Row className={`tests ${report.data.info.categoryStatus.tests.status}`}>
                        <Grid.Column width={4}>
                            <Statistic>
                                <Statistic.Label>Unit Tests</Statistic.Label>
                                <Statistic.Value>
                                    {report.data.tests.tests}
                                    <small>({reportHelper.getChange( 'data.tests.tests' )})</small>
                                </Statistic.Value>
                            </Statistic>
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <UnitTestChart pkg={pkg} fetchType={match.params.fetchType} />
                        </Grid.Column>
                    </Grid.Row>


                    <Grid.Row className={`maintainability ${report.data.info.categoryStatus.maintainability.status}`}>
                        <Grid.Column width={4}>
                            <Statistic>
                                <Statistic.Label>Maintainability</Statistic.Label>
                                <Statistic.Value>
                                    {report.data.plato.average.maintainability}
                                    <small>({reportHelper.getChange( 'data.plato.average.maintainability' )})</small>
                                </Statistic.Value>
                            </Statistic>
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <MaintainabilityChart pkg={pkg} fetchType={match.params.fetchType} />
                        </Grid.Column>
                    </Grid.Row>


                    <Grid.Row className={`duplicate`}>
                        <Grid.Column width={4}>
                            <Statistic>
                                <Statistic.Label>Duplicate LOC</Statistic.Label>
                                <Statistic.Value>
                                    {report.data.duplicateCode.lines}
                                    <small>({reportHelper.getChange( 'data.duplicateCode.lines' )})</small>
                                </Statistic.Value>
                            </Statistic>
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <DuplicateCodeChart pkg={pkg} fetchType={match.params.fetchType} />
                        </Grid.Column>
                    </Grid.Row>


                    <Grid.Row className={`loc`}>
                        <Grid.Column width={4}>
                            <Statistic>
                                <Statistic.Label>LOC</Statistic.Label>
                                <Statistic.Value>
                                    {report.data.plato.total.sloc}
                                    <small>({reportHelper.getChange( 'data.plato.total.sloc' )})</small>
                                </Statistic.Value>
                            </Statistic>
                        </Grid.Column>

                        <Grid.Column width={12}>
                            <LOCChart pkg={pkg} fetchType={match.params.fetchType} />
                        </Grid.Column>
                    </Grid.Row>

                </Grid>

            </Container>
        );
    }
}

export default GraphsSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/Graphs.js